import {GetOneUserCommand, type GetOneUserResponse} from '@perfectpost/perfect-post-common';
import {queryOptions, useQuery} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {userKeys} from '../keys';

/** Options partagées avec `usePublicUsersQuery`, qui les monte en lot. */
export const oneUserOptions = (id: string) =>
  queryOptions({
    queryKey: userKeys.one(id),
    queryFn: (): Promise<GetOneUserResponse> => sendOrThrow(new GetOneUserCommand({id})),
  });

/**
 * Fiche publique d'un utilisateur.
 *
 * Remplace les `perfectPostServiceClient.send(new GetOneUserCommand({id}))`
 * écrits dans un `useEffect` + `useState` par chaque composant qui affiche
 * quelqu'un d'autre (`DraftChatBox`, `TeamInvitationModal`, `DraftSharing`). Une
 * même fiche demandée par deux composants n'est lue qu'une fois.
 */
export function useOneUserQuery(id: string | undefined) {
  return useQuery({
    ...oneUserOptions(id ?? ''),
    enabled: id !== undefined,
  });
}
